import React from "react";
import Typography from "@material-ui/core/Typography";

export default function ListErrors({ errors }) {
  return (
    <div>
      {errors.length !== 0
        ? errors.map((element) => {
            return (
              <Typography color="error" variant="h9" gutterBottom>
                {element} {}
              </Typography>
            );
          })
        : null}
    </div>
  );
}
